import fdc from './fdc/en.js'

export default {
  fdc
}
